import {RouteConfig} from 'vue-router';
import {
	META_ALLOW_ANONYMOUS_ACCESS,
	ERouteName,
	RequireActiveLocationId, LocationStore,
	DisplayStore,
	RequireServiceTypeId,
	RoutingUtils,
} from '@customer-portal/shared';

const routes: RouteConfig[] = [
	{
		path: '/login',
		component: () => {
			// TODO: can we move this up to the top level once everything is updated? Maybe one with and one without header
			return import('components/layouts/FullPageResponsive.vue');
		},
		props: {
			hideHeader: true,
		},
		children: [
			{
				name: ERouteName.Login,
				path: '',
				component: () => {
					return import('components/user/LoginPage.vue');
				}
			}
		],
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/accept-tos',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.AcceptTOS,
				path: '',
				component: () => {
					return import('components/pages/AcceptTOS.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/app-install-reward',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'App Install Reward',
				path: '',
				component: () => {
					return import('components/pages/AppInstallReward.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/opportunity/:id',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Unclaimed Reward',
				path: '',
				component: () => {
					return import('components/pages/UnclaimedReward.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/nps/:id',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Unclaimed NPS',
				path: '',
				component: () => {
					return import('components/pages/UnclaimedNPSPage.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '',
		name: ERouteName.Launch,
		props: {
			bounceToHome: 'true' // string booleans are gross but the only thing supported
		},
		component: () => {
			return import('components/pages/AppLaunch.vue');
		},
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/home',
		component: () => {
			return import('components/layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Home,
				path: '',
				component: () => {
					return import('components/pages/Home.vue');
				},
				props: {
					handleScreenPops: 'false'
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/landing/:campaignId',
		name: ERouteName.Landing,
		component: () => import('@/components/pages/Landing.vue'),
		props: true,
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/specials',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Specials',
				path: '',
				component: () => {
					return import('components/pages/Specials.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/loyalty-info',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Loyalty Info',
				path: '',
				component: () => {
					return import('components/pages/LoyaltyInfo.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{

		path: '/map',
		component: () => {
			return import('components/layouts/FullPageResponsive.vue');
		},
		props: () => ({
			hideHeader: !DisplayStore.isDesktop
		}),
		children: [
			{
				name: ERouteName.Map,
				path: '',
				component: () => {
					return import('components/pages/MapPage.vue');
				},
				meta: {
					requiresAuth: true,
				},
			},
			{
				name: ERouteName.OrderLocations,
				path: 'locations',
				component: () => {
					return import('components/order/OrderLocations.vue');
				},
			},
			{
				path: 'locations/:locationID',
				name: ERouteName.OrderLocation,
				component: () => {
					return import('components/order/OrderLocations.vue');
				},
				props: true,
			},
		],
	},
	{
		path: '/locations',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.Locations,
				path: '',
				component: () => {
					return import('components/pages/Locations.vue');
				},
				meta: {
					requiresAuth: true
				}
			},
			{
				path: ':serviceId',
				beforeEnter: (to, _from, next) => {
					// Find location by serviceId
					const location = LocationStore.locations.find(loc => loc.serviceId === to.params.serviceId);

					if(location) {
						// Set the locationId parameter to open modal
						next({name: ERouteName.OrderLocation, params: {locationID: location.id}, replace: true});
					} else {
						console.error('no location found for service id');
						next({name: ERouteName.OrderLocations, replace: true});
					}
				},
				meta: {
					requiresAuth: false
				}
			}
		]
	},
	{
		path: '/menu',
		component: () => {
			return import('components/layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Menu,
				path: '',
				component: () => {
					return import('components/pages/Menu.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	// {
	// 	path: '/public-menu',
	// 	component: () => {
	// 		return import('components/layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Public Menu',
	// 			path: '',
	// 			component: () => {
	// 				return import('components/pages/Menu.vue');
	// 			},
	// 			meta: {
	// 				requiresAuth: false
	// 			}
	// 		}
	// 	]
	// },
	{
		path: '/visit',
		component: () => {
			return import('components/layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.VisitDetail,
				path: '',
				component: () => {
					return import('components/pages/Visit.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/rewards',
		component: () => {
			return import('components/layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Reward,
				path: '',
				component: () => {
					return import('components/pages/Rewards.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{

		path: '/profile',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.Profile,
				path: '',
				component: () => {
					return import('components/pages/Profile.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/qr-code',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.QRCode,
				path: '',
				component: () => {
					return import('components/pages/QRCode.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/mobile',
		component: () => {
			return import('components/layouts/MobileWebView.vue');
		},
		children: [
			{
				name: 'Tokenize',
				path: 'tokenize',
				component: () => {
					return import('components/pages/TokenizeMobilePay.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/delete-account',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.AccountDelete,
				path: '',
				component: () => {
					return import('components/pages/DeleteAccount.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/order',
		component: () => {
			return import('components/layouts/FullPageResponsive.vue');
		},
		children: [
			{
				name: ERouteName.Order,
				path: '',
				component: () => {
					return import('components/order/OrderPage.vue');
				},
				meta: {
					requireActiveLocationId: true,
					requireServiceTypeId: true,
				},
				beforeEnter: RoutingUtils.chainGuards([RequireActiveLocationId, RequireServiceTypeId]),
				children: [
					{
						name: ERouteName.MenuCategory,
						path: 'menu-category/:menuCategoryId',
						props: true,
						component: () => {
							return import('components/order/menu-category/MenuCategory.vue');
						},
						meta: {
							requiresAuth: true
						},
						beforeEnter: RoutingUtils.chainGuards([RequireActiveLocationId, RequireServiceTypeId]),
					},
					{
						path: 'cart',
						component: () => {
							return import('components/order/OrderPage.vue');
						},
					},
					{
						path: 'item/:itemID',
						component: () => {
							return import('components/order/OrderPage.vue');
						},
						props: true, // This stopped working in e7bfaf6a3dc510b637a3af34ee80d5500548fd9c
					},
				],
				props: true, // allows showLocation in app initialization
			},
		]
	},
	{
		path: '/order-tracker/',
		component: () => {
			return import('components/layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.OrderTracker,
				path: ':ticketId',
				component: () => {
					return import('components/order/OrderTrackerPage.vue');
				},
				props: true,
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		name: ERouteName.ThankYou,
		path: '/thank-you/:ticketId',
		component: () => {
			return import('components/order/ThankYou.vue');
		},
		props: true,
		meta: {
			requiresAuth: true
		},
	},
	{
		path: '/share/:hash',
		name: ERouteName.Share,
		component: () => import('@/components/pages/Share404.vue'),
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/egc/:qrCode',
		name: ERouteName.EGiftCard,
		component: () => import('@/components/pages/egc/EGiftCardPage.vue'),
		props: true,
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	// {
	// 	path: '/push-notification-request',
	// 	component: () => {
	// 		return import('components/layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Push Notification Request',
	// 			path: '',
	// 			component: () => {
	// 				return import('components/pages/PushNotificationRequest.vue');
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/push-notification-disabled',
	// 	component: () => {
	// 		return import('components/layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Push Notification Disabled',
	// 			path: '',
	// 			component: () => {
	// 				return import('components/pages/PushNotificationsDisabled.vue');
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/test',
	// 	component: () => {
	// 		return import('components/layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Test',
	// 			path: '',
	// 			component: () => {
	// 				return import('components/pages/Test.vue');
	// 			}
	// 		}
	// 	]
	// },
	// {
	//
	// 	path: '/pay',
	// 	component: () => {
	// 		return import('components/layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Pay',
	// 			path: '',
	// 			component: () => {
	// 				return import('components/pages/Pay.vue');
	// 			}
	// 		}
	// 	]
	// },

	// Always leave this as last one,
	// but you can also remove it
	{
		path: '*',
		component: () => {
			return import('components/pages/Error404.vue');
		}
	}
];

export default routes;
